export const roundToCurrency = (value: number): number => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};

export const isPositiveCurrency = (
  value: number | null | undefined,
): value is number => {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
};

export const normalizeCurrencyValue = (
  value: number | null | undefined,
): number => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return 0;
  }

  return roundToCurrency(value);
};

export const formatBRLCurrency = (value: number): string => {
  return Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value || 0);
};
